<template>
  <div>
    <v-dialog
      max-width="800"
      persistent
      transition="dialog-bottom-transition"
      v-model="showDialog"
    >
      <v-card :loading="loading">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>Create Environments</v-toolbar-title>
        </v-toolbar>
        <v-card flat v-if="listShowcaseEnvironments">
          <v-card-title>
            Existing Locations
          </v-card-title>
          <v-card-text v-if="existingLocations.length > 0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th scope="col" class="text-left">Account</th>
                    <th scope="col" class="text-left">Region</th>
                    <th scope="col" class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="location in existingLocations"
                    :key="location.accountId + location.region"
                  >
                    <td>{{ location.accountId }}</td>
                    <td>
                      {{ location.region }}
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
            Multiple environemts possible for Showcase: {{ showcase.multiEnv }}
          </v-card-text>
          <v-card-text v-if="existingLocations.length === 0">
            No environments found
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat v-if="existingLocations.length > 0 && !showcase.multiEnv">
          <v-card-text>
            <v-alert type="warning">
              Creating more environments not possible!
            </v-alert>
          </v-card-text>
        </v-card>
        <v-card
          flat
          v-if="existingLocations.length === 0 || !showcase.multiEnv"
        >
          <v-card-title>
            Select Target Locations
          </v-card-title>
          <v-card-text v-if="selectedLocations.length < 1 || showcase.multiEnv">
            <v-row no-gutters>
              <v-col cols="5">
                <v-select
                  class="location-select"
                  v-model="accountSelect"
                  :items="accountItems"
                  label="Account"
                  @change="setAvailableRegions"
                >
                </v-select>
              </v-col>
              <v-col cols="5">
                <v-select
                  v-model="regionSelect"
                  v-bind:items="availableRegions"
                  class="location-select"
                  label="Region"
                >
                </v-select
              ></v-col>
              <v-col cols="2"
                ><v-btn
                  icon
                  color="green"
                  @click="addTargetLocation"
                  :disabled="!accountSelect || !regionSelect"
                  ><v-icon>mdi-plus</v-icon></v-btn
                ></v-col
              >
            </v-row>
          </v-card-text>
          <v-card-text v-if="selectedLocations.length > 0">
            <v-simple-table>
              <template v-slot:default>
                <thead>
                  <tr>
                    <th scope="col" class="text-left">Account</th>
                    <th scope="col" class="text-left">Region</th>
                    <th scope="col" class="text-left"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    v-for="location in selectedLocations"
                    :key="location.accountId + location.region"
                  >
                    <td>{{ location.accountId }}</td>
                    <td>
                      {{ location.region }}
                    </td>
                    <td>
                      <v-btn
                        icon
                        color="red"
                        @click="removeTargetLocation(location)"
                        ><v-icon>mdi-minus</v-icon></v-btn
                      >
                    </td>
                  </tr>
                </tbody>
              </template>
            </v-simple-table>
          </v-card-text>
        </v-card>
        <v-divider></v-divider>
        <v-card flat v-if="createEnvsPossible">
          <v-card-title>
            Run Options
          </v-card-title>
          <v-card-text>
            <v-row no-gutters>
              <v-col cols="3">
                <v-radio-group v-model="scheduleOrNow" :mandatory="true">
                  <v-radio label="Run now" value="now"></v-radio>
                  <v-radio label="Schedule" value="schedule"></v-radio>
                </v-radio-group>
              </v-col>
              <v-col cols="9">
                <CloudWatchCronExpressionBuilder
                  v-model="scheduleExpression"
                  v-if="schedule"
                  show-next-events="5"
                >
                </CloudWatchCronExpressionBuilder>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-btn
            @click="runOperation()"
            :disabled="selectedLocations.length === 0"
            >Run</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
import {
  CREATE_ENVIRONMENTS,
  SCHEDULE_CREATE_ENVIRONMENTS,
  LIST_SHOWCASE_ENVIRONMENTS
} from '@/domain/showcases/constants/query'
import { DOMAIN_NAME } from '@/domain/showcases'
import CloudWatchCronExpressionBuilder from '@/components/CWCronExpressionBuilder/CloudWatchCronExpressionBuilder'
import { isScheduleOnceType } from '@/domain/showcases/util/schedule'

export default {
  name: 'ShowcaseOperationsExecution',
  components: {
    CloudWatchCronExpressionBuilder
  },
  data: () => ({
    showDialog: true,
    loading: false,
    scheduleOrNow: 'now',
    scheduleExpression: '',
    message: null,
    accountItems: [
      { text: 'PM (042161511592)', value: '042161511592' },
      { text: 'Sales (681457385121)', value: '681457385121' },
      { text: 'Barakaldo (017003736700)', value: '017003736700' }
    ],
    accountSelect: null,
    regionItems: [
      { text: 'eu-west-1', value: 'eu-west-1' },
      { text: 'eu-west-2', value: 'eu-west-2' },
      { text: 'eu-central-1', value: 'eu-central-1' },
      { text: 'us-east-1', value: 'us-east-1' }
    ],
    regionSelect: null,
    availableRegions: [],
    selectedLocations: [],
    listShowcaseEnvironments: [],
    listShowcaseEnvironmentsErrors: null
  }),
  props: ['showcase'],
  computed: {
    schedule: function() {
      return this.scheduleOrNow === 'schedule'
    },
    existingLocations: function() {
      return this.listShowcaseEnvironments
        .filter(environment => environment.status !== 'DELETED')
        .map(environment => {
          return {
            region: environment.region,
            accountId: environment.accountId
          }
        })
    },
    createEnvsPossible() {
      return (
        this.listShowcaseEnvironments.length === 0 || this.showcase.multiEnv
      )
    }
  },
  methods: {
    setAvailableRegions() {
      let existingRegions = this.existingLocations
        .filter(location => location.accountId === this.accountSelect)
        .map(location => location.region)
      let selectedRegions = this.selectedLocations
        .filter(location => location.accountId === this.accountSelect)
        .map(location => location.region)

      this.availableRegions = this.regionItems.filter(
        region =>
          !existingRegions.includes(region.value) &&
          !selectedRegions.includes(region.value)
      )
    },
    addTargetLocation() {
      this.selectedLocations.push({
        accountId: this.accountSelect,
        region: this.regionSelect
      })
      this.accountSelect = null
      this.regionSelect = null
    },
    removeTargetLocation(location) {
      let itemIndex = this.selectedLocations.indexOf(location)
      if (itemIndex >= 0) {
        this.selectedLocations.splice(itemIndex, 1)
      }

      this.accountSelect = null
      this.regionSelect = null
    },
    runOperation() {
      this.message = 'Starting Operation'

      let operationHandler =
        this.scheduleOrNow === 'now'
          ? this.operationHandler
          : this.scheduleOperationHandler
      this.message = 'Starting Operation'
      operationHandler()
        .then(response => {
          this.loading = false
          this.message = 'Success!'
          this.closeDialog()
        })
        .catch(err => {
          this.loading = false
          this.message = err
        })
    },
    async operationHandler() {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: CREATE_ENVIRONMENTS,
        variables: {
          showcaseId: this.showcase.showcaseId,
          targets: this.selectedLocations
        },
        fetchPolicy: 'no-cache'
      })
    },
    async scheduleOperationHandler() {
      return this.$apolloProvider.clients['SHOWCASE'].mutate({
        mutation: SCHEDULE_CREATE_ENVIRONMENTS,
        variables: {
          showcaseId: this.showcase.showcaseId,
          targets: this.selectedLocations,
          scheduleExpression: 'cron(' + this.scheduleExpression + ')',
          scheduleType: isScheduleOnceType(this.scheduleExpression)
            ? 'ONCE'
            : 'PERIODIC'
        },
        fetchPolicy: 'no-cache'
      })
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  apollo: {
    $client: DOMAIN_NAME,
    listShowcaseEnvironments: {
      query: LIST_SHOWCASE_ENVIRONMENTS,
      variables() {
        return { showcaseId: this.showcase.showcaseId }
      },
      skip() {
        return !this.showcase
      },
      error(error) {
        this.listShowcaseEnvironmentsErrors = JSON.stringify(error.message)
      }
    }
  }
}
</script>

<style scoped>
.location-select {
  width: 80%;
}
</style>
